<template>
  <div class="glod-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="promoteOperation('add')" class="add-input">+新增配置</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="domain" label="网址" align="left" min-width="350">
        <template slot-scope="scope">
          <!-- <span>{{scope.row.domain || '未知'}}</span> -->
          <div v-for="item in scope.row.domain" :key="item.url">
            <div class="urlStatus" :style="item.status === 0 ? {background:'#eefdee',color:'#62b106'}:{background:'#ccc',color:'red'}">
            <span>权重：{{item.weight}},</span>
            <span>url：{{item.url}}</span>
            <span>{{item.status === 0 ?'正常': '被封'}}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" min-width="240">

        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="240">

        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="120">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="promoteOperation('edit',scope.row)"></el-button>
          <!-- <el-button type="danger" size="mini" icon="el-icon-delete" @click="removePromote(scope.row.id)"></el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <!-- 没得分页
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 1" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    -->
    <!--新增、编辑弹框-->
    <promote-action ref="promoteAction" @handlerPromoteList="getPromoteList('status')"></promote-action>
  </div>
</template>

<script>
import API from '@/api'
import PromoteAction from "./components/promoteAction"
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        //pageNumber: 1,
        //pageSize: 10
      }
    }
  },
  components: {
    PromoteAction
  },
  created() {
    // this.$store.dispatch('setRouterTag', { router: '/administrators', routerName: "系统管理员" })
    this.getPromoteList()
  },
  methods: {
    // 请求推广落地页列表
    getPromoteList(type) {
      if (type === 'status') {
        this.params.pageNumber = 1
      }
      this.loading = true;
      API.getPromoteList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = [res.data]
          this.total = res.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 删除推广落地页配置
    removePromote(id) {
      this.$confirm('您确定要删除当前推广落地页配置吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.delPromote({ ids: [id] }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除推广落地页配置成功',
                type: 'success'
              })
              this.getPromoteList()
            } else {
              this.$message.error('删除推广落地页配置失败')
            }
          })
        })
        .catch(() => { });
    },
    // 新增、编辑操作
    promoteOperation(type, data) {
      this.$refs.promoteAction.open(type, data)
    }
  }
}
</script>

<style lang="scss">
.promote-list-box {
  .add-input {
    margin-left: 0 !important;
  }
}
.urlStatus{
  margin:4px 0; 
  padding: 0 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
</style>
